<template>
  <div>
    <div class="w1100">
     	<div class="floatL leftnr marginT10">
        <div class="is-title">{{channel.nameChn}}</div>
            <div class="is-menu" v-if="moduleList">
              <template v-for="item in moduleList">
                <div :key="'module-item'+item.nameChn">
                  <h1 v-if="item.id == 6150">
                    <a :href="'/qsxf-web/module/list?code='+item.id" :title="item.nameChn" target="_self">
                    {{item.nameChn}}
                    </a>
                  </h1>
                  <h1 v-else-if="item.id == 6154 || item.id == 6150 || item.id == 6204">
                    <a :href="'/qsxf-web/module/index?code='+item.id" :title="item.nameChn" target="_self">
                    {{item.nameChn}}
                    </a>
                  </h1>
                  <h1 v-else>
                    <a :href="'/qsxf-web/module/list?code='+item.id" :title="item.nameChn" target="_self">
                    {{item.nameChn}}
                    </a>
                  </h1>
                </div>  
              </template>
        </div>
        <!--通知公告-->
        <div class="is-title marginT10">通知公告</div>
          <div class="ph_List f14">
            <ul>
              <li v-for="(item ,i) in this.noticeList" :key="'notice'+item.id+i">
                  <a class="title" :title="item.title" :href="'/qsxf-web/detail?id='+item.id" target="_blank" style="">{{item.title}}</a>
              </li>
            </ul>
          </div>      
        </div>
       	<div class="floatR marginT10" style="width:777px;">
        	<div class="is-postion fb">
                <div class="is-posbg">您当前的位置：
                  <a href="/">网站首页</a>
                  <template v-if="channel"> / <span>{{channel.nameChn}}</span></template>
                  <template v-if="currentChannel"> / <span>{{currentChannel.nameChn}}</span></template>
            	</div>
          	</div>
			  <div style="border:1px solid #E0E0E0; border-top:none; padding-top:15px;">
            
                
            <div class="tr f14" v-for="(item ,i) in this.list" :key="'module'+item.id+i">
                <div class="txt1 floatL f14 a1 ellipsis">
                  <a class="title" :title="item.title" :href="'/qsxf-web/detail?id='+item.id" target="_blank" style="">{{item.title}}</a>
                </div>
                <div class="listtime floatL">{{item.timePublish.substring(0,10)}}</div>
                <div class="clear"></div>
            </div>
    
            <div class="paging">
              <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="pageIndex"
                  :page-size="pageSize"
                  layout="total, prev, pager, next"
                  :total="totalCount">
              </el-pagination>  
            </div>
                
            </div>
        </div>
        <div class="clear"></div>
    </div>
  </div>
</template>


<script>

import request from '@/common/request'
import  '../assets/css/css.css'

export default {
  name: 'ModuleListIndex',
  data () {
    return {
        pageIndex:1,
        pageSize:20,
        totalCount:0,
        code:null,
        list:[],
        noticeList:[],
        moduleList:[],
        channel:{},
        currentChannel:{}
    }
  },
  watch: {
    $route(to, from){
        this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
      init:function(){
        this.code = this.$route.query.code;
        this.getContentByChannel(this.code,this.pageIndex,this.pageSize).then(data=>{
          if(data.errorCode == 0 && data.result && data.result.list){
            this.list = data.result.list;
            this.totalCount = data.result.totalCount;
          }
        });

        //获取通知公告
        this.getContentByChannel(6178,1,10).then(data=>{
          if(data.errorCode == 0 && data.result && data.result.list){
            this.noticeList = data.result.list;
          }
        });

        //获取模块
        this.getModuleList(this.code).then(data=>{
          if(data.errorCode == 0 && data.result && data.result.list){
            this.moduleList = data.result.list;
            this.channel = data.result.channel;
            this.currentChannel = data.result.currentChannel;
          }
        });
      },
      handleCurrentChange(val) {
        this.pageIndex = val;
        this.getContentByChannel(this.code,this.pageIndex,this.pageSize).then(data=>{
          if(data.errorCode == 0 && data.result && data.result.list){
            this.list = data.result.list;
            this.totalCount = data.result.totalCount;
          }
        });
      },
      getContentByChannel:function(code,pageIndex,pageSize){
        return request({
          url: '/index/getContentByChannel',
          method: 'get',
          params: { 
            "pageIndex":pageIndex,
            "pageSize":pageSize,
            "id":code
          }
        })
      },
      getModuleList:function(code){
        return request({
          url: '/index/getModuleList',
          method: 'get',
          params: {
            "id":code
          }
        })
      }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ModuleListIndex.vue